import { FC } from "react"

const Arrow: FC = () => <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.77 -0.000469208L0 1.76953L10 11.7695L20 1.76953L18.23 -0.000469208L10 8.22953L1.77 -0.000469208Z" fill="black"/>
</svg>


export default Arrow;
